export default __webpack_public_path__ + "static/media/greendragonplasma.fe271600.PNG";